import { Trip2ThemeModule } from './../../trip2-theme/trip2-theme.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExcludeProvidersComponent } from './components/exclude-providers/exclude-providers.component';
import { ExcludeProviderService } from './exclude-providers.service';
import { DualListBoxModule } from '../dual-list-box/dual-list-box.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DualListBoxModule,
    Trip2ThemeModule,
  ],
  declarations: [ExcludeProvidersComponent],
  exports: [
    ExcludeProvidersComponent
  ],
  providers: [ExcludeProviderService]
})
export class ExcludeProvidersModule {}



// WEBPACK FOOTER //
// ./src/app/utils/exclude-providers/exclude-providers.module.ts